// Major Paint Vendor Database
export const PAINT_VENDORS = {
  'Benjamin Moore': [
    { name: 'White Dove', code: 'OC-17', hex: '#F3F1E7' },
    { name: 'Chantilly Lace', code: 'OC-65', hex: '#F7F7F5' },
    { name: 'Simply White', code: 'OC-117', hex: '#F4F0EA' },
    { name: 'Decorator\'s White', code: 'CC-20', hex: '#EFEDE8' },
    { name: 'Cloud White', code: 'OC-130', hex: '#E8E6DD' },
    { name: 'Swiss Coffee', code: 'OC-45', hex: '#EFE9DC' },
    { name: 'Ballet White', code: 'OC-9', hex: '#EBE7E0' },
    { name: 'Classic Gray', code: 'OC-23', hex: '#D1CEC7' },
    { name: 'Revere Pewter', code: 'HC-172', hex: '#C6BAAC' },
    { name: 'Edgecomb Gray', code: 'HC-173', hex: '#D2CAB8' },
    { name: 'Gray Owl', code: 'OC-52', hex: '#CAD1CD' },
    { name: 'Stonington Gray', code: 'HC-170', hex: '#B5BDB9' },
    { name: 'Wickham Gray', code: 'HC-171', hex: '#C0BCB5' },
    { name: 'Chelsea Gray', code: 'HC-168', hex: '#A39D93' },
    { name: 'Kendall Charcoal', code: 'HC-166', hex: '#6C6D6C' },
    { name: 'Hale Navy', code: 'HC-154', hex: '#3D4F5C' },
    { name: 'Van Deusen Blue', code: 'HC-156', hex: '#455966' },
    { name: 'Gentleman\'s Gray', code: 'OC-23', hex: '#9FA19F' },
    { name: 'Pale Oak', code: 'OC-20', hex: '#D8D1C3' },
    { name: 'Collingwood', code: 'OC-28', hex: '#CFC7B9' }
  ],
  'Sherwin Williams': [
    { name: 'Agreeable Gray', code: 'SW 7029', hex: '#D1CBC1' },
    { name: 'Alabaster', code: 'SW 7008', hex: '#EDEADE' },
    { name: 'Pure White', code: 'SW 7005', hex: '#F3F1EB' },
    { name: 'Extra White', code: 'SW 7006', hex: '#F4F2ED' },
    { name: 'Snowbound', code: 'SW 7004', hex: '#E8E5DC' },
    { name: 'Incredible White', code: 'SW 7028', hex: '#E2DFD4' },
    { name: 'Greek Villa', code: 'SW 7551', hex: '#EBE7DA' },
    { name: 'Accessible Beige', code: 'SW 7036', hex: '#D6CCB8' },
    { name: 'Worldly Gray', code: 'SW 7043', hex: '#C2BDB0' },
    { name: 'Repose Gray', code: 'SW 7015', hex: '#C9CABE' },
    { name: 'Mindful Gray', code: 'SW 7016', hex: '#B8B5A8' },
    { name: 'Anew Gray', code: 'SW 7030', hex: '#C7C1B5' },
    { name: 'Incredible White', code: 'SW 7028', hex: '#E2DFD4' },
    { name: 'Naval', code: 'SW 6244', hex: '#2D3C4D' },
    { name: 'Tricorn Black', code: 'SW 6258', hex: '#2D2A27' },
    { name: 'Iron Ore', code: 'SW 7069', hex: '#4C4A48' },
    { name: 'Urbane Bronze', code: 'SW 7048', hex: '#63605B' },
    { name: 'Sea Salt', code: 'SW 6204', hex: '#D4DDDA' },
    { name: 'Rainwashed', code: 'SW 6211', hex: '#CFD9D5' },
    { name: 'Silver Strand', code: 'SW 7057', hex: '#C9D3CF' }
  ],
  'Farrow & Ball': [
    { name: 'All White', code: '2005', hex: '#F4F1EA' },
    { name: 'Wimborne White', code: '239', hex: '#E3DDD4' },
    { name: 'Strong White', code: '2001', hex: '#EFEEE8' },
    { name: 'Pointing', code: '2003', hex: '#E8E4DC' },
    { name: 'Cornforth White', code: '228', hex: '#D4CBC1' },
    { name: 'Pavilion Gray', code: '242', hex: '#C8C3B8' },
    { name: 'Elephant\'s Breath', code: '229', hex: '#B9B1A7' },
    { name: 'Purbeck Stone', code: '275', hex: '#BFB8AD' },
    { name: 'Skimming Stone', code: '241', hex: '#D6D0C5' },
    { name: 'String', code: '8', hex: '#CABFA9' },
    { name: 'Hague Blue', code: '30', hex: '#2C394B' },
    { name: 'Railings', code: '31', hex: '#3B3E41' },
    { name: 'Off-Black', code: '57', hex: '#2D2D2E' },
    { name: 'Down Pipe', code: '26', hex: '#3C4046' },
    { name: 'Studio Green', code: '93', hex: '#4E5C55' },
    { name: 'Pigeon', code: '25', hex: '#A39E96' },
    { name: 'Dove Tale', code: '267', hex: '#A29E94' },
    { name: 'Mizzle', code: '266', hex: '#BDB9AE' },
    { name: 'Shaded White', code: '201', hex: '#E4DFD7' },
    { name: 'Slipper Satin', code: '2004', hex: '#E7DFCE' }
  ],
  'Behr': [
    { name: 'Ultra Pure White', code: 'PR-W15', hex: '#F5F3EE' },
    { name: 'Polar Bear', code: '75', hex: '#F0EDE6' },
    { name: 'Bit of Sugar', code: 'PPU18-6', hex: '#E8E3D9' },
    { name: 'Wheat Bread', code: 'PPU5-13', hex: '#D8CFBD' },
    { name: 'Classic Silver', code: 'N520-2', hex: '#C7C1B8' },
    { name: 'Burnished Clay', code: 'N220-3', hex: '#B5ADA1' },
    { name: 'Broadway', code: 'PPU18-17', hex: '#9C9489' },
    { name: 'Aged Beige', code: 'N270-4', hex: '#C1B8AA' },
    { name: 'Silver Drop', code: 'PPU26-15', hex: '#B8B5AE' },
    { name: 'Dolphin Fin', code: 'N450-4', hex: '#9B9C9A' },
    { name: 'Elephant Skin', code: 'N360-4', hex: '#A7A39A' },
    { name: 'Cracked Pepper', code: 'PPU18-1', hex: '#656158' },
    { name: 'Broadway', code: 'PPU18-17', hex: '#9C9489' },
    { name: 'Starless Night', code: 'N500-7', hex: '#3A3C3E' },
    { name: 'Carbon', code: 'N520-7', hex: '#48443F' },
    { name: 'Ultra Pure White', code: 'PR-W15', hex: '#F5F3EE' },
    { name: 'Silky White', code: 'PPU7-12', hex: '#EBE6D9' },
    { name: 'Cameo White', code: 'PPU7-13', hex: '#E4DFD2' },
    { name: 'Champagne', code: 'PPU5-10', hex: '#E7E0D1' },
    { name: 'Natural Almond', code: 'PPU5-12', hex: '#DCD3C3' }
  ],
  'Valspar': [
    { name: 'Ultra White', code: '7006-6', hex: '#F3F0E8' },
    { name: 'Bistro White', code: '7006-19', hex: '#EAE6DD' },
    { name: 'Honeymilk', code: '7003-18', hex: '#E8E2D4' },
    { name: 'Woodlawn Silver Brook', code: 'HC-165', hex: '#D2CBC0' },
    { name: 'Bonsai', code: '6008-4A', hex: '#B9B6AC' },
    { name: 'Montpelier', code: 'HC-171', hex: '#C0BCB5' },
    { name: 'Coastal Villa', code: '7004-1', hex: '#CEC9BE' },
    { name: 'Frappe', code: '7006-24', hex: '#B7AFA3' },
    { name: 'Smoky Pitch', code: '5004-10A', hex: '#4A4C4E' },
    { name: 'Rugged Suede', code: '4003-6A', hex: '#847669' },
    { name: 'Cafe Blue', code: '5002-5A', hex: '#6B7B85' },
    { name: 'Seine', code: '5002-4A', hex: '#8A989F' },
    { name: 'Wet Cement', code: '5001-3A', hex: '#A4AAA8' },
    { name: 'Nordic Gray', code: '5003-4A', hex: '#969994' },
    { name: 'Woodrow Wilson Putty', code: 'HC-172', hex: '#C5BDB0' },
    { name: 'Filtered Shade', code: '7006-28', hex: '#DDD8CC' },
    { name: 'Bistro White', code: '7006-19', hex: '#EAE6DD' },
    { name: 'Dove White', code: '7006-21', hex: '#E6E1D6' },
    { name: 'Lyndhurst Gallery Beige', code: 'HC-96', hex: '#D9D1C1' },
    { name: 'Tempered Gray', code: '7006-16', hex: '#C1BBB0' }
  ]
};

// Get all colors from all vendors
export const getAllPaintColors = () => {
  const allColors = [];
  Object.entries(PAINT_VENDORS).forEach(([vendor, colors]) => {
    colors.forEach(color => {
      allColors.push({ ...color, vendor });
    });
  });
  return allColors;
};

// Search colors by name
export const searchPaintColors = (query) => {
  const allColors = getAllPaintColors();
  const lowerQuery = query.toLowerCase();
  return allColors.filter(color => 
    color.name.toLowerCase().includes(lowerQuery) ||
    color.code.toLowerCase().includes(lowerQuery) ||
    color.vendor.toLowerCase().includes(lowerQuery)
  );
};

// Get colors by vendor
export const getColorsByVendor = (vendor) => {
  return PAINT_VENDORS[vendor] || [];
};